import { useEffect, useRef, useState } from "react";
import { trimLettersFromUserName } from "../utilityClass";
import { off, onValue, ref } from "firebase/database";
import { realtimeDB } from "../Backend";
import { HbrMic, HbrMicOff } from "../MyCustomsvgicons";
import { HbrHandsUpFemale, HbrHandsUpMaleIcon } from "../largeSvgIcons";

const PeerVideosContent = ({peerName, peerid, roomKey}) => {
        const [offMic, setMicOff] = useState(false);
        const [camOff, setCamOff] = useState(false);
        const [isHandUp, setIsHandUp] = useState(false);
        const [gender, setGender] = useState("");
        const textViewRef = useRef(null);

        useEffect(()=>{
            const micStatusRef = ref(realtimeDB, `roompeers${roomKey}/${peerid}/micoff`);
            const camStatusRef = ref(realtimeDB, `roompeers${roomKey}/${peerid}/camoff`);
            const handsUpRef = ref(realtimeDB, `roompeers${roomKey}/${peerid}/handsUp`);
            
            const miclistener =  onValue(micStatusRef, (snapshot)=>{
                if (snapshot.exists()) {
                    const micState = snapshot.val();
                    setMicOff(micState);
                }
            });

            const camlistener =  onValue(camStatusRef, (snapshot)=>{
                if (snapshot.exists()) {
                    const camState = snapshot.val();
                    setCamOff(camState);
                }
            });
            const onHandsUp =  onValue(handsUpRef, (snapshot)=>{
                if (snapshot.exists()) {
                    const handIsUp = snapshot.child("raised").val();
                    const genderType = snapshot.child("genderType").val();
                    setIsHandUp(handIsUp);
                    setGender(genderType);
                }
            });
    
            return()=>{
                off(micStatusRef, 'value', miclistener);
                off(camStatusRef, 'value', camlistener);
                off(handsUpRef, 'value', onHandsUp);
            };
    
        },[peerid, roomKey]);

        useEffect(()=>{
            if (camOff && textViewRef.current) {
              trimLettersFromUserName(peerName, textViewRef.current);
            }
        },[peerName, camOff]);

    return ( 
        <div className="peer-videos-content" style={{width:"100%", height:"100%"}}>
            <div className="other-peers-mics">
                    {offMic ? 
                (<div><HbrMicOff width={"1em"} height={"1em"} fillColour={"white"}/></div>)
                :
                (<div >
                    <HbrMic width={"1em"} height={"1em"} fillColour={"white"}/>
                </div>
                )}
            </div>
            <div className="other-peers-hand-gesture">
                {isHandUp && gender === "male" ? 
                <HbrHandsUpMaleIcon
                width={'2em'} 
                height={'2em'}
                />
                :
                isHandUp && gender === "female" ?
                <HbrHandsUpFemale
                width={'2em'} 
                height={'2em'}
                />
                :
                <p>{""}</p>
                }
            </div>
            <div className={`other-peers-webcam ${camOff ? 'off':'active'} flex-column2`}>
                <p className="other-peers-inactive-cam-name" ref={textViewRef}></p>
            </div>
        </div>
     );
}
export default PeerVideosContent;